import { render, staticRenderFns } from "./ScoringAnswerList.vue?vue&type=template&id=21365403&"
import script from "./ScoringAnswerList.vue?vue&type=script&lang=js&"
export * from "./ScoringAnswerList.vue?vue&type=script&lang=js&"
import style0 from "./ScoringAnswerList.vue?vue&type=style&index=0&id=21365403&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports